<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { requestPushPermissions } from 'dashboard/helper/pushHelper';

const LS_KEY = 'push_notification_banner_dismissed';

export default {
  components: { Banner },
  data() {
    return { dismissed: false };
  },
  computed: {
    shouldShowBanner() {
      return (
        !this.dismissed &&
        !localStorage.getItem(LS_KEY) &&
        Notification.permission === 'default'
      );
    },
    bannerMessage() {
      return this.$t('SETTINGS.PUSH_NOTIFICATION_BANNER.MESSAGE');
    },
  },
  methods: {
    handleEnableNotifications() {
      this.dismissed = true;
      localStorage.setItem(LS_KEY, 'true');
      requestPushPermissions({ onSuccess: () => {} });
    },
    dismissBanner() {
      this.dismissed = true;
      localStorage.setItem(LS_KEY, 'true');
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="black"
    :banner-message="bannerMessage"
    :has-action-button="true"
    :action-button-label="$t('SETTINGS.PUSH_NOTIFICATION_BANNER.ENABLE_BUTTON')"
    action-button-icon="i-lucide-bell"
    action-button-variant="solid"
    has-close-button
    :show-extra-close-icon="true"
    @primaryAction="handleEnableNotifications"
    @close="dismissBanner"
  />
</template>
